export function websocketsUri(path) {
  const loc = window.location;
  let protocol;
  if (loc.protocol === 'https:') {
    protocol = 'wss:';
  } else {
    protocol = 'ws:';
  }
  return `${protocol}//${loc.host}${path}`;
}



// WEBPACK FOOTER //
// ./src/app/helpers/websockets.js